var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Title"}},[_c('b-input',{attrs:{"placeholder":"e.g Newsletter"},model:{value:(_vm.content.title),callback:function ($$v) {_vm.$set(_vm.content, "title", $$v)},expression:"content.title"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }